import axios from './axios'
import NProgress from 'nprogress'
import { Result } from './model'

interface Reauest {
  responseType: string
  get<T>(url: string, params?: unknown): Promise<Result<T>>
  post<T>(url: string, params?: unknown, responseType?: any): Promise<Result<T>>
  upload<T>(url: string, params: unknown): Promise<Result<T>>
  download(url: string): void
}

const request: Reauest = {
  get(url, params) {
    return new Promise((resolve, reject) => {
      NProgress.start()
      axios
        .get(url, { params })
        .then((res) => {
          NProgress.done()
          resolve(res.data)
        })
        .catch((err) => {
          NProgress.done()
          reject(err.data)
        })
    })
  },
  post(url, obj?: any, isArraybuffer?) {
    const { switchApi, ...params } = obj || {}
    return new Promise((resolve, reject) => {
      NProgress.start()
      axios
        .post(switchApi || url, JSON.stringify(params), { responseType: isArraybuffer ? 'arraybuffer' : 'json' })
        .then((res) => {
          NProgress.done()
          resolve(res.data)
        })
        .catch((err) => {
          NProgress.done()
          reject(err.data)
        })
    })
  },
  upload(url, file) {
    return new Promise((resolve, reject) => {
      NProgress.start()
      axios
        .post(url, file, {
          headers: { 'Content-Type': 'multipart/form-data' }
        })
        .then((res) => {
          NProgress.done()
          resolve(res.data)
        })
        .catch((err) => {
          NProgress.done()
          reject(err.data)
        })
    })
  },
  download(url) {
    const iframe = document.createElement('iframe')
    iframe.style.display = 'none'
    iframe.src = url
    iframe.onload = function () {
      document.body.removeChild(iframe)
    }
    document.body.appendChild(iframe)
  },
  responseType: ''
}
export default request
